import { action, observable } from 'mobx';
import { handleDisconnectRoom } from 'components/LiveClass/utils/disconnect';
import { RoomStatus } from '../../utils/consts';

class RoomStore {
  @observable.ref roomStatus = RoomStatus.NotCreated;

  roomName = '';

  roomToken = '';

  classId = '';

  joinId = '';

  @observable.ref createdBy = '';

  @observable.ref twilioRoom = null;

  constructor(store) {
    this.store = store;
  }

  @action
  init(room) {
    this.roomName = room.roomName;
    this.roomToken = room.roomToken;
    this.joinId = room.joinId;
    this.classId = room.classId;
    this.createdBy = room.createdBy;

    const twilioRoom = room.twilioRoom;
    this.twilioRoom = twilioRoom;

    this.twilioRoom
      .off('disconnected', this.handleRoomDisconnect)
      .on('disconnected', this.handleRoomDisconnect);
  }

  disconnect() {
    // disconnect from twilio room and release other
    // resources
    if (this.twilioRoom) {
      try {
        this.twilioRoom.disconnect();
      } catch (e) {
        console.log('Error while disconnecting from room', e);
      }
    }
  }

  handleRoomDisconnect = (room, error) => {
    // Room Completed
    if (error && error.code === 53118) {
      this.store.endLiveClass.isPopupVisible = true;
    }
    handleDisconnectRoom(room);
  };
}

export default RoomStore;
